import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics, isSupported as isAnalyticsSupported } from 'firebase/analytics';

let firebaseApp = null;
let firebaseAnalytics = null;

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig();

  const firebaseConfig = {
    apiKey: config.public.firebase_api_key,
    authDomain: config.public.firebase_auth_domain,
    projectId: config.public.firebase_project_id,
    storageBucket: config.public.firebase_storage_bucket,
    messagingSenderId: config.public.firebase_messaging_sender_id,
    appId: config.public.firebase_app_id,
    measurementId: config.public.firebase_measurement_id,
  };

  firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);

  if (await isAnalyticsSupported()) {
    const analytics = getAnalytics(firebaseApp);
    firebaseAnalytics = analytics;
  }

  nuxtApp.provide('firebaseApp', firebaseApp);
  nuxtApp.provide('firebaseAnalytics', firebaseAnalytics);
});
